import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { __assign, __rest } from "tslib";
import { uniCall } from '../../utils';
import { withDefaultOption } from '../../utils/with-default-option';
/**
 * 在新的 Web View 容器中打开页面
 */

export function openInWebView(opt) {
  return new Promise(function (resolve) {
    var _a, _b, _c, _d, _e;

    if (typeof opt.url !== 'string' || !opt.url) {
      throw new Error("[openInWebView] expected parameter \u201Curl\u201D is non-empty string, got \u201C".concat(opt.url, "\u201D"));
    }

    var _f = opt.parseWebViewOptionFromURL,
        parseWebViewOptionFromURL = _f === void 0 ? false : _f,
        newOpt = __rest(opt, ["parseWebViewOptionFromURL"]); // url 可以不指定域名


    if (!/^(?:https?:)?\/\//.test(newOpt.url)) {
      newOpt.url = "".concat(location.origin).concat(newOpt.url);
    }

    if (parseWebViewOptionFromURL) {
      var index = newOpt.url.indexOf('?');

      if (index >= 0) {
        var params = new URLSearchParams(newOpt.url.slice(index));

        try {
          var webViewOption = JSON.parse(params.get('webview.option'));

          if (webViewOption) {
            // handle `statusBar`
            if (!('statusBar' in newOpt) && 'statusBar' in webViewOption) {
              if (((_a = webViewOption.statusBar) === null || _a === void 0 ? void 0 : _a.visible) === false) {
                newOpt.statusBar = false;
              } else {
                newOpt.statusBar = webViewOption.statusBar;
              }
            } // handle `navigationBar`


            if (!('navigationBar' in newOpt) && 'navigationBar' in webViewOption) {
              if (((_b = webViewOption.navigationBar) === null || _b === void 0 ? void 0 : _b.visible) === false) {
                newOpt.navigationBar = false;
              } else {
                newOpt.navigationBar = webViewOption.navigationBar;
              }
            } // handle `loadingBar`


            if (!('loadingBar' in newOpt) && 'loadingBar' in webViewOption) {
              if (((_c = webViewOption.loadingBar) === null || _c === void 0 ? void 0 : _c.visible) === false) {
                newOpt.loadingBar = false;
              } else {
                newOpt.loadingBar = webViewOption.loadingBar;
              }
            } // handle `orientation`


            if (!('orientation' in newOpt) && 'orientation' in webViewOption) {
              newOpt.orientation = webViewOption.orientation;
            } // handle `touchCallout`


            if (!('touchCallout' in newOpt) && 'touchCallout' in webViewOption) {
              newOpt.touchCallout = ((_d = webViewOption.touchCallout) === null || _d === void 0 ? void 0 : _d.enabled) !== false;
            } // handle `bouncingScroll`


            if (!('bouncingScroll' in newOpt) && 'bouncingScroll' in webViewOption) {
              newOpt.bouncingScroll = ((_e = webViewOption.bouncingScroll) === null || _e === void 0 ? void 0 : _e.enabled) !== false;
            } // handle `autoSafeArea`


            if (!('autoSafeArea' in newOpt) && 'autoSafeArea' in webViewOption) {
              newOpt.autoSafeArea = Boolean(webViewOption.autoSafeArea);
            }
          }
        } catch (err) {// do nothing
        }
      }
    }

    var option = withDefaultOption({
      statusBar: true,
      navigationBar: true,
      loadingBar: true,
      orientation: {
        angle: 0
      },
      touchCallout: true,
      bouncingScroll: true,
      autoSafeArea: true
    }, newOpt);
    var statusBar = withDefaultOption({
      color: 'black'
    }, __assign(__assign({}, typeof option.statusBar === 'object' ? option.statusBar : {}), {
      visible: Boolean(option.statusBar)
    }));
    var navigationBar = withDefaultOption({
      color: 'black',
      bgColor: '#FFFFFF'
    }, __assign(__assign({}, typeof option.navigationBar === 'object' ? option.navigationBar : {}), {
      visible: Boolean(option.navigationBar)
    }));
    var loadingBar = withDefaultOption({
      color: '#124EE6',
      bgColor: '#FFFFFF'
    }, __assign(__assign({}, typeof option.loadingBar === 'object' ? option.loadingBar : {}), {
      visible: Boolean(option.loadingBar)
    }));
    var param = {
      url: option.url,
      statusBar: statusBar,
      navigationBar: navigationBar,
      loadingBar: loadingBar,
      orientation: option.orientation,
      touchCallout: {
        enabled: Boolean(option.touchCallout)
      },
      bouncingScroll: {
        enabled: Boolean(option.bouncingScroll)
      },
      autoSafeArea: Boolean(option.autoSafeArea)
    };
    uniCall({
      api: 'openInWebView',
      param: param
    });
    resolve();
  });
}